module.exports = __webpack_public_path__ + "img/cst_profile.0847a790.svg";